export enum OrganizationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    CONFIGURING = 'CONFIGURING'
}
